module.exports = __webpack_public_path__ + "img/ic_safe.1f26c46f.svg";